import React, { useState } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-scroll";
import "./Header.css";
const Header = () => {
  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 90) {
      setColor(true);
    } else {
      setColor(false);
    }
  };
  window.addEventListener("scroll", changeColor);
  return (
    <div className="container">
      <Navbar
        fixed="top"
        expand="lg"
        className={color ? "header-bg" : "header"}
      >
        <Container>
          <Navbar.Brand className="brand">
            <span className="namet">Al Shadab</span>{" "}
            <span className="name">Arnab</span>
          </Navbar.Brand>
          <Navbar.Toggle
            style={{ backgroundColor: "white" }}
            aria-controls="basic-navbar-nav"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto justify-content-end flex-grow-1 pe-3">
              <Link
                className="link"
                to="home"
                spy={true}
                smooth={true}
                offset={-100}
                duration={100}
              >
                HOME
              </Link>

              <Link
                to="about"
                className="link"
                spy={true}
                smooth={true}
                offset={-60}
                duration={100}
              >
                ABOUT
              </Link>
              <Link
                className="link"
                to="service"
                spy={true}
                smooth={true}
                offset={-60}
                duration={100}
              >
                SERVICES
              </Link>
              <Link
                className="link"
                to="portfolio"
                spy={true}
                smooth={true}
                offset={-60}
                duration={100}
              >
                PORTFOLIO
              </Link>
              <Link
                className="link"
                to="blog"
                spy={true}
                smooth={true}
                offset={-60}
                duration={100}
              >
                BLOG
              </Link>
              <Link
                className="link"
                to="certificate"
                spy={true}
                smooth={true}
                offset={-60}
                duration={100}
              >
                CERTIFICATES
              </Link>
              <Link
                className="link"
                to="contact"
                spy={true}
                smooth={true}
                offset={-60}
                duration={100}
              >
                CONTACT
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
